import { render, staticRenderFns } from "./CourseDetails.vue?vue&type=template&id=75519027&scoped=true"
import script from "./CourseDetails.vue?vue&type=script&lang=js"
export * from "./CourseDetails.vue?vue&type=script&lang=js"
import style0 from "./CourseDetails.vue?vue&type=style&index=0&id=75519027&prod&scoped=true&lang=css"
import style1 from "./CourseDetails.vue?vue&type=style&index=1&id=75519027&prod&scoped=true&lang=css"
import style2 from "./CourseDetails.vue?vue&type=style&index=2&id=75519027&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75519027",
  null
  
)

export default component.exports